import { render, staticRenderFns } from "./DropdownInput.vue?vue&type=template&id=37b097b8&"
import script from "./DropdownInput.vue?vue&type=script&lang=js&"
export * from "./DropdownInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports